import type { InferOutput } from "valibot";
import { type Options, useMutation } from "../useMutation";
import { type RequestProgramInputSchema, RequestProgramOutputSchema } from "./schemaTypes";

export const useRequestProgramMutation = (options?: Options<InferOutput<RequestProgramOutputSchema>>) => {
  return useMutation<RequestProgramInputSchema, RequestProgramOutputSchema>(
    "/api/request-program/",
    RequestProgramOutputSchema,
    options,
  );
};
